import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Link } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import React from "react";
import CloseIcon from '@material-ui/icons/Close';

import {Link as MuiLink, useTheme } from "@material-ui/core/";
import { constant } from "lodash";
import { EditProjectItems } from "../myprojects/EditProjectItems";
import { EditReportResultsItems } from "./EditReportResultsItems";


export const EditReportResults = ({report_data}: any) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(!open);
  };
  
  return (
    <>
      <Button
        color="primary"
        onClick={handleClose}
        startIcon={<Edit />}/>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={false}>
        <DialogTitle id="id">
          <div>
          <Box display="flex" alignItems="center">
            <Box flexGrow={1} >{"Update Report Info"}</Box>
            <Box>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          
          </div>
        </DialogTitle>

        <DialogContent>
        <Divider variant="fullWidth" />
        <EditReportResultsItems report_data={report_data} handleClose={handleClose}/>
        </DialogContent>
        
        <DialogActions>
        </DialogActions>
      </Dialog>
    </>
  )
};
